module.exports = __webpack_public_path__ + "static/img/5_2.11eeb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/5_2.png
// module id = r6Uk
// module chunks = 1